// components/GenerationLimitModal.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CreditCard, Zap, Layout, GitBranch, Clock } from 'lucide-react';

const GenerationLimitModal = ({ onClose, isExpired = false, subscriptionStatus = "trial" }) => {
  const navigate = useNavigate();

  const handlePurchase = () => {
    navigate('/payment');
  };

  // Show different content based on subscription status
  const renderContent = () => {
    if (subscriptionStatus === "trial") {
      return (
        <>
          <div className="inline-flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100 text-yellow-600 mb-3">
            <Zap size={24} />
          </div>
          <h2 className="text-xl font-bold mb-2">Trial Generations Used</h2>
          <p className="text-gray-600">
            You've used all your free trial generations.
          </p>
        </>
      );
    } else if (subscriptionStatus === "expired") {
      return (
        <>
          <div className="inline-flex items-center justify-center h-12 w-12 rounded-full bg-orange-100 text-orange-600 mb-3">
            <Clock size={24} />
          </div>
          <h2 className="text-xl font-bold mb-2">Access Pass Expired</h2>
          <p className="text-gray-600">
            Your access pass has expired. Purchase a new pass to continue creating and revising views.
          </p>
        </>
      );
    } else {
      // Default case for any other status
      return (
        <>
          <div className="inline-flex items-center justify-center h-12 w-12 rounded-full bg-red-100 text-red-600 mb-3">
            <CreditCard size={24} />
          </div>
          <h2 className="text-xl font-bold mb-2">Access Required</h2>
          <p className="text-gray-600">
            Purchase an access pass to continue using this feature.
          </p>
        </>
      );
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg p-6 shadow-xl max-w-md w-full mx-4">
        <div className="text-center mb-4">
          {renderContent()}
        </div>

        <div className="bg-gray-50 p-4 rounded-lg mb-6">
          <h3 className="font-semibold text-gray-800 mb-3">Upgrade to unlock:</h3>
          <ul className="space-y-2">
            <li className="flex items-start">
              <div className="flex-shrink-0 h-5 w-5 text-green-500 mr-2">
                <Layout size={18} />
              </div>
              <p className="text-gray-600">Unlimited view generation</p>
            </li>
            <li className="flex items-start">
              <div className="flex-shrink-0 h-5 w-5 text-green-500 mr-2">
                <GitBranch size={18} />
              </div>
              <p className="text-gray-600">Unlimited view revisions</p>
            </li>
            <li className="flex items-start">
              <div className="flex-shrink-0 h-5 w-5 text-green-500 mr-2">
                <Zap size={18} />
              </div>
              <p className="text-gray-600">Share or export your designs</p>
            </li>
          </ul>
        </div>

        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={handlePurchase}
            className="px-4 py-2 bg-black text-white rounded-md hover:bg-gray-800 flex items-center"
          >
            <CreditCard className="mr-2" size={16} />
            Purchase Access Pass
          </button>
        </div>
      </div>
    </div>
  );
};

export default GenerationLimitModal;